export function initNavigation() {
  if ($(".sidebar-container").length == 0 || $("#sidebar-toggle").length == 0) {
    return;
  }
  const $button = document.querySelector("#sidebar-toggle");
  const $wrapper = document.querySelector("#wrapper");

  $button.addEventListener("click", (e) => {
    e.preventDefault();
    $wrapper.classList.toggle("toggled");
  });
}

export function sidebarNavUI() {
  if ($(".sidebar-container").length == 0) {
    return;
  }
  if (window.location.href.includes("redemption_option_id%5D=32")) {
    $("#sidebar-wrapper .donations").addClass("active");
  } else if (
    window.location.href.includes("dashboard/cash_back") ||
    window.location.href.includes("redemption_option_id")
  ) {
    $("#sidebar-wrapper .cashback").addClass("active");
  } else if (window.location.href.includes("missing")) {
    $("#sidebar-wrapper .missing-rewards-link").addClass("active");
  } else if (window.location.href.includes("extension")) {
    $("#sidebar-wrapper .extension-bill-link").addClass("active");
  } else if (window.location.href.includes("in_stay")) {
    $("#sidebar-wrapper .instay").addClass("active");
  } else if (window.location.href.includes("cash_forward")) {
    $("#sidebar-wrapper .cash-forward").addClass("active");
  } else if (window.location.href.includes("account")) {
    $("#sidebar-wrapper .profile").addClass("active");
  } else if (window.location.href.includes("referral_program")) {
    $("#sidebar-wrapper .referral-program-link").addClass("active");
  } else if (window.location.href.includes("membersonlydeals")) {
    $("#sidebar-wrapper .member-deals").addClass("active");
  } else {
    $("#sidebar-wrapper .overview").addClass("active");
  }

  if (window.location.href.includes("stays")) {
    $(".rewards-table .nav-link.stays").addClass("active");
  }

  if (window.location.href.includes("missing")) {
    $(".rewards-table .nav-link.missing-rewards").addClass("active");
  }
}
